import axios from 'axios';

let base = 'https://apw.simcotech.net/wash';

let baseall = 'https://apw.simcotech.net';
let bass='wss://apw.simcotech.net';

//上传图片
export const UploadImage = params => { return axios.post(`${baseall}/uploadImage`, params).then(res => res.data); };
//机构操作
export const requestLogin = params => { return axios.post(`${base}/organ/organ_login`, params).then(res => res.data); };

//export const getUserList = params => { return axios.post(`${base}/organ/organs_list`, { params: params }); };

export const getOrganList = params => { return axios.post(`${base}/organ/organs_list`, params ); };

export const getOrganDetail = params => { return axios.post(`${base}/organ/get_organ_name`, params ); };

export const removeOrgan = params => { return axios.post(`${base}/organ/delete_organ`, params ); };

export const batchRemoveUser = params => { return axios.post(`${base}/user/batchremove`, { params: params }); };

export const editUser = params => { return axios.post(`${base}/organ/edit_organ`,params)};

export const setOrganDetail = params => { return axios.post(`${base}/organ/detail_organ`,params)};//修改机构详情

export const setOrganPower = params => { return axios.post(`${base}/organ/set_organ_power`,params)};//设置机构权限验证

export const edit_organPassword = params => { return axios.post(`${base}/organ/edit_organPassword`,params)};

export const edit_organUserPassword = params => { return axios.post(`${base}/organ/edit_organUserPassword`,params)};

export const add_organ = params => { return axios.post(`${base}/organ/add_organ`,params)};//新增机构

export const getDeviceList = params => { return axios.post(`${base}/device/getDeviceList`,params)};//设备操作

export const getDevice_link_cord = params => { return axios.post(`${base}/device/getDevice_link_cord`,params)};//获取连接记录

export const getUserList = params => { return axios.post(`${base}/user/users_list`,params)};//查询机构所属用户

export const sendPhoneNumber = params => { return axios.post(`${baseall}/user/send_phone`,params)};//发送验证码

export const phoneVerify = params => { return axios.post(`${baseall}/user/phone_verify`,params)};//发送验证码



//白名单
export const addWhite = params => { return axios.post(`${base}/white/add_white`,params)};

export const deleteWhite = params => { return axios.post(`${base}/white/delete_white`,params)};

export const whiteList = params => { return axios.post(`${base}/white/white_list`,params)};

//红名单
export const addRed = params => { return axios.post(`${base}/red/add_red`,params)};

export const deleteRed = params => { return axios.post(`${base}/red/delete_red`,params)};

export const redList = params => { return axios.post(`${base}/red/red_list`,params)};


export const long_range = params => { return axios.post(`${bass}`,params)};//远程控制

//分配权限
export const addAssignPower = params => { return axios.post(`${base}/power/add_assign_power`,params)};

export const assignPowerList = params => { return axios.post(`${base}/power/assign_power_list`,params)};

export const deleteAssignPower = params => { return axios.post(`${base}/power/delete_assign_power`,params)};

//创建二维码
export const addCreatePower = params => { return axios.post(`${base}/power/add_create_power`,params)};

export const createPowerList = params => { return axios.post(`${base}/power/create_power_list`,params)};

export const deleteCreatePower = params => { return axios.post(`${base}/power/delete_create_power`,params)};

//设备库存列表
export const getDeviceReperdoryList = params => { return axios.post(`${base}/device/get_deviceReperdory`,params)};

//分配差异查询
export const getDeviceArea = params => { return axios.post(`${base}/device/get_device_area`,params)};

//生产用户
export const addProduct = params => { return axios.post(`${base}/producter/add_product`,params)};

export const productList = params => { return axios.post(`${base}/producter/product_list`,params)};

export const deleteProduct = params => { return axios.post(`${base}/producter/delete_product`,params)};



// WEBPACK FOOTER //
// ./src/api/api.js